<template>
  <div class="nx-picture">
    <div
      :class="getStyle"
      @click="handleClick"
    >
      <nx-image
        v-for="(item,index) in filterImgList"
        :key="index"
        :src="item.url"
        :inner-text="item.innerText"
      >
      </nx-image>
    </div>
  </div>
</template>

<script>
/**
 * 九宫格图片组件
 * author: 颜必行
 */
import { ImagePreview } from 'vant';

export default {
  name: 'NxPicture',
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      perfectLength: [1, 4, 9],
    };
  },
  computed: {
    filterImgList() {
      const length = this.imgList.length;

      const LengthReverse = [...this.perfectLength].reverse();
      const coordinate = LengthReverse.find(len => length - len >= 0);
      const innerNum = length - coordinate;

      const filterList = this.imgList.slice(0, coordinate);
      const lastIndex = filterList.length - 1;

      return filterList.map((item, index) => {
        return {
          url: item,
          innerText: index === lastIndex ? innerNum !== 0 ? `+${innerNum}` : '' : '',
        };
      });
    },
    getStyle() {
      const length = this.imgList.length;
      const perfectLength = this.perfectLength;
      if (length >= perfectLength[0] && length < perfectLength[1]) {
        return 'small-box';
      }
      else if (length >= perfectLength[1] && length < perfectLength[2]) {
        return 'medium-box';
      }
      else if (length >= perfectLength[2]) {
        return 'large-box';
      }
      else {
        return 'none-box';
      }
    },
  },
  created() {
  },
  methods: {
    handleClick() {
      ImagePreview(this.imgList);
    },
  },
};
</script>
<style lang="scss">
.none-box{
    height: 0;
    display: none;
}
.small-box,.medium-box,.large-box{
    height: 339px;
    width: 339px;
    margin: 0 auto;
    border-radius: 8px;
    overflow: hidden;
}
.medium-box{
    display: grid;
    grid-template-columns: 168px 168px;
    grid-template-rows: 168px 168px;
    grid-gap: 3px;
}
.large-box{
    display: grid;
    grid-template-columns: 111px 111px 111px;
    grid-template-rows: 111px 111px 111px;
    grid-gap: 3px;
}
</style>
